import { render, staticRenderFns } from "./ComfortCreditDetail.vue?vue&type=template&id=d0545a12&scoped=true"
import script from "./ComfortCreditDetail.vue?vue&type=script&lang=js"
export * from "./ComfortCreditDetail.vue?vue&type=script&lang=js"
import style0 from "./ComfortCreditDetail.vue?vue&type=style&index=0&id=d0545a12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0545a12",
  null
  
)

export default component.exports